import { Cookies } from 'quasar'

function isDevMachine () {
  return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname)
}
export default {
  has: async function (cookieName) {
    // console.log('RJMDEBUG400 capicatorDetect.cookies has', cookieName)
    return Cookies.has(cookieName)
  },
  get: async function (cookieName) {
    // console.log('RJMDEBUG400 capicatorDetect.cookies get', cookieName, Cookies.get(cookieName))
    return Cookies.get(cookieName)
  },
  set: async function (cookieName, value) {
    // Return value never used
    // console.log('RJMDEBUG400 capicatorDetect.cookies set', cookieName, value)
    Cookies.set(cookieName, value, {
      secure: !isDevMachine(), // otherwise cookie not set on dev machines
      expires: 36500, // 100 years
      path: '/'
    })
  },
  remove: async function (cookieName) {
    console.log('RJMDEBUG400 capicatorDetect.cookies remove', cookieName)
    Cookies.remove(cookieName, { path: '/' })
  }
}
